import { render, staticRenderFns } from "./RoleAndPermissionsEdit.vue?vue&type=template&id=acafbe98&scoped=true&"
import script from "./RoleAndPermissionsEdit.vue?vue&type=script&lang=js&"
export * from "./RoleAndPermissionsEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleAndPermissionsEdit.vue?vue&type=style&index=0&id=acafbe98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acafbe98",
  null
  
)

export default component.exports